import race from '@assets/dictionary/race';
import { province } from '@assets/dictionary/provinces'
import { city } from '@assets/dictionary/cities'
import areas from '@assets/dictionary/areas'
import moment from 'moment';

/**
 * 密码验证
 * @param {*} pwd
 */
export const checkPwd = (pwd) => {
  let check = 0;
  for (let i = 0; i < pwd.length; i++) {
    let c = pwd[i].charCodeAt();
    if (c < 33 || c > 126) {
      return false;
    }
    if (c >= 65 && c <= 90) {
      check = check | (1 << 0);
    } else if (c >= 97 && c <= 122) {
      check = check | (1 << 1);
    } else if (c >= 48 && c <= 57) {
      check = check | (1 << 2);
    } else {
      check = check | (1 << 3);
    }
  }
  let count = 0;
  for (let i = 0; i < 4; i++) {
    if ((check & (1 << i)) > 0) {
      count++;
    }
  }
  return count >= 3;
};

/**
 *  鉴权
 * @param perm
 * @param type 1234 增删改查
 */
export const checkPerm = (perm, type) => {
  if(typeof perm !== 'number') {
    return 0;
  }
  switch (type) {
    case 1: return parseInt(perm % 2);
    case 2: return parseInt(perm % 4 / 2);
    case 3: return parseInt(perm % 8 / 4);
    case 4: return parseInt(perm % 8);
    default: return 0;
  }
}

/**
 * 民族
 * @param {*} 民族编号
 */
export const showChinesRace = (e) => {
  for (let i = 0; i < race.length; i++) {
      if (e === race[i].id) {
          return race[i].name;
      }
  }
}

/**
 * 地址编码转文字
 * @param {*} x 地址编码obj
 */
export const setDwAdress = (x = {}) => {
  let a = x.provinceCode;
  let b = x.cityCode;
  let c = x.areaCode;
  let dwAdress = '';
  for (let i = 0; i < province.length; i++) {
      if (province[i].code == a) {
          dwAdress += province[i].name + ' ';
      }
  }
  for (let i = 0; i < city.length; i++) {
      if (city[i].code == b) {
          dwAdress += city[i].name + ' ';
      }
  }
  for (let i = 0; i < areas.length; i++) {
      if (areas[i].code == c) {
          dwAdress += areas[i].name + ' ';
      }
  }
  return dwAdress;
}

/**
 * 字典转换文字
 * @param e: 待转
 * @param obj： 字典
 */
export const showChines = (e, obj = []) => {
  for (let i = 0; i < obj.length; i++) {
      if (e === obj[i].value) {
          return obj[i].valueText;
      }
  }
}

/**
 * 将对象中值为moment类型的转为时间戳
 * @param params: {}
 * @return object
 */
export const doParseMomentType = (params = {}) => {
  const noParamReassign = params;
  Object.entries(params).forEach(([key, value]) => {
    value instanceof moment &&
    value.isValid() &&
    (noParamReassign[key] = value.unix());
  });
  return noParamReassign;
}

// 去收尾空格
export const normalize = (value) => {
  if (typeof value === "string") {
    return value.trim();
  }
  return value;
};
export const limitDecimals = (value) => {
  const end = value.split(".")?.[1];
  if ((end && end?.length > 2) || isNaN(Number(value))) {
    return value.slice(0, value.length - 1);
  } else {
    return value;
  }
};

export function garvinLog(...param) {
  console.log(`%c GARVINLOG ↓ \n`, 'margin-left: 1%;border-radius: 20px;font-size:14px;background:gray;color:rgb(2, 245, 132);font-weight: bold;', ...param);
}
